"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { ArrowRight, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="4458" id="hero" className="bg-background text-foreground relative overflow-hidden pt-[120px] pb-24 lg:pb-32">
      <div className="mx-auto max-w-[1440px] grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-0 items-center">
        {}
        <div ref={textRef} className="lg:col-span-3 px-6 sm:px-10 lg:pl-20 lg:pr-16 relative" style={{
        opacity: textVisible ? 1 : 0,
        transform: textVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 1.2s ease-out, transform 1.2s ease-out"
      }}>
          {}
          <span aria-hidden="true" className="font-default pointer-events-none select-none absolute -top-8 -left-4 lg:-top-12 lg:left-8 text-[180px] sm:text-[240px] lg:text-[320px] leading-none text-foreground/[0.08] tracking-tighter" style={{
          fontWeight: 700
        }}>
            SECURE
          </span>

          <div className="relative">
            {}
            <div className="flex items-center gap-3 mb-10">
              <span className="block h-px w-10 bg-primary" aria-hidden="true" />
              <p className="font-default uppercase" style={{
              color: "var(--primary)",
              fontSize: "11px",
              letterSpacing: "0.22em"
            }}>
                AI-Powered Cybersecurity — Proactive Defense
              </p>
            </div>

            {}
            <h1 className="font-default font-bold text-foreground tracking-tight leading-[0.95] text-[56px] sm:text-[72px] lg:text-[96px]">
              <span className="block">AI-Powered</span>
              <span className="block">Cybersecurity</span>
              <span className="block">
                <span className="relative inline-block font-bold text-primary">
                  for Modern
                </span>
                <span className="text-foreground"> Businesses.</span>
              </span>
            </h1>

            {}
            <p className="mt-10 max-w-[480px] text-[17px] leading-[1.65] text-muted-foreground font-default">
              InfinitySecure protects your digital assets with advanced AI-driven threat detection, 24/7 monitoring, and proactive risk management. Stay secure in an ever-evolving digital landscape.
            </p>

            {}
            <div className="mt-12 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
              <Button asChild size="lg" className="rounded-lg h-14 px-8 bg-primary text-primary-foreground hover:bg-primary/90 font-default uppercase tracking-[0.18em] text-[11px] shadow-md">
                <Link to="/ContactPage">
                  <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
                  Get a Free Assessment
                </Link>
              </Button>

              <Button asChild size="lg" variant="ghost" className="rounded-lg h-14 px-8 border border-border bg-transparent text-foreground hover:bg-accent hover:text-accent-foreground font-default uppercase tracking-[0.18em] text-[11px]">
                <Link to="/ExpertisePage">
                  Explore Services
                  <ArrowRight className="size-4" />
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-16 flex items-center gap-4">
              <span className="block h-px w-6 bg-border" aria-hidden="true" />
              <p className="font-default text-[10px] uppercase tracking-[0.24em] text-muted-foreground">
                InfinitySecure — Protecting Your Future, Today
              </p>
            </div>
          </div>
        </div>

        {}
        <div ref={imgRef} className="lg:col-span-2 relative w-full" style={{
        opacity: imgVisible ? 1 : 0,
        transform: imgVisible ? "translateX(0)" : "translateX(40px)",
        transition: "opacity 1.4s ease-out, transform 1.4s ease-out"
      }}>
          <div className="relative w-full aspect-[4/5] overflow-hidden rounded-lg shadow-lg">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/ai_cybersecurity_dashboard.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/ai_cybersecurity_dashboard.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/ai_cybersecurity_dashboard.webp-wvc-sizes" alt="Advanced AI-powered cybersecurity threat monitoring dashboard" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />

            {}
            <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent pointer-events-none" />

            {}
            <div className="absolute bottom-6 left-6 sm:bottom-8 sm:left-8 flex items-center gap-3">
              <span className="block h-px w-6 bg-primary" aria-hidden="true" />
              <p className="font-default text-foreground/90 text-sm sm:text-[15px]" style={{
              fontWeight: 500
            }}>
                24/7 Active Defense
              </p>
            </div>

            {}
            <div className="absolute top-6 right-6 sm:top-8 sm:right-8 flex items-center gap-2">
              <span className="font-default text-[10px] uppercase tracking-[0.24em] text-foreground/70">
                AI-DRIVEN
              </span>
              <span className="block h-px w-6 bg-foreground" style={{
              opacity: 0.4
            }} aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}